import { contains } from 'lodash';

export default function simpleSearch(list: any[], key: string, fields: string[]) {
  return list.filter((search) => {
    const fullString = fields.map(field => search[field] || '').join('\n');

    return contains(fullString.toLowerCase(), key.toLowerCase());
  });
}